import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getIdData } from "../../../lib/studentinfo";

export default function STopMenu({ slug, activeMenu }) {
  const [studentInfo, setStudentInfo] = useState(0);

  async function GetData() {
    const info = await getIdData(slug);
    setStudentInfo(info[0].id);
  }

  useEffect(() => {
    GetData();
  }, []);
console.log("studentInfo",studentInfo);

  return (
    <>
      <div className="settings-widget">
        <div className="settings-inner-blk">
          <div className="sell-course-head">
            <div className="sidebar-tag-labels">
              <ul className="list-unstyled justify-content-around p-3 instructor_labels">
                <li className="">
                  <Link
                    to={`/student/student-tasklist`}
                    className={
                      activeMenu === "Task"
                        ? "fw-bolder text-decoration-underline  "
                        : ""
                    }
                  >
                    Agenda
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/student/student-gradeinmonth`}
                    className={
                      activeMenu === "GradeList"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    Current Grades
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/student/student-activity`}
                    className={
                      activeMenu === "Activity"
                        ? "fw-bolder text-decoration-underline  "
                        : ""
                    }
                  >
                    Activities
                  </Link>
                </li>
               
                <li>
                  <Link
                    to={`/student/student-booklist`}
                    className={
                      activeMenu === "BookList"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    Reading Books
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/student/student-goal-questions`}
                    className={
                      activeMenu === "GoalGrades"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    Goal Settings
                  </Link>
                </li>

                <li>
                  <Link
                    to={`/student/student-transkript`}
                    className={
                      activeMenu === "Transkript"
                        ? "fw-bolder text-decoration-underline text-center"
                        : "text-center"
                    }
                  >
                    Transcript Planning
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/student/student-personal-questions`}
                    className={
                      activeMenu === "PersonalQuestions"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    Personality Assessment
                  </Link>
                </li>
                <li>
                  <Link
                    to={`/student/student-notes`}
                    className={
                      activeMenu === "Notes"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    Notes
                  </Link>
                </li>                
                <li>
                  <Link
                    to={`/student/college_list/${studentInfo}`}
                    className={
                      activeMenu === "StudentCollegeListIndex"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    College List
                  </Link>
                </li>                
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="settings-widget">
        <div className="settings-inner-blk">
          <div className="sell-course-head">
            <div className="sidebar-tag-labels">
              <ul className="list-unstyled justify-content-around p-3 instructor_labels">
                <li className="bg-info-subtle">
                  <Link
                    to={`/student/student-checklist`}
                    className={
                      activeMenu === "Profile"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    CheckList
                  </Link>
                </li>

                <li className="bg-info-subtle">
                  <Link
                    to={`/student/student-curriculum-table`}
                    className={
                      activeMenu === "Profile"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    Application Calendar
                  </Link>
                </li>

                <li className="bg-info-subtle">
                  <Link
                    to={`/student/student-mainessay`}
                    className={
                      activeMenu === "Profile"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    Main Essay
                  </Link>
                </li>

                <li className="bg-info-subtle">
                  <Link
                    to={`/student/student-supplementalessay`}
                    className={
                      activeMenu === "Profile"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    Supplementary Essay
                  </Link>
                </li>

                <li className="bg-info-subtle">
                  <Link
                    to={`/student/student-additionalinfo`}
                    className={
                      activeMenu === "Profile"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    Additional Info
                  </Link>
                </li>

                <li className="bg-info-subtle">
                  <Link
                    to={`/student/student-bragsheet`}
                    className={
                      activeMenu === "Profile"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    Brag Sheet
                  </Link>
                </li>

                <li className="bg-info-subtle">
                  <Link
                    to={`/student/student-schedulelist`}
                    className={
                      activeMenu === "Profile"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    Schedule
                  </Link>
                </li>

                <li className="bg-info-subtle">
                  <Link
                    to={`/student/student-resource`}
                    className={
                      activeMenu === "Profile"
                        ? "fw-bolder text-decoration-underline  text-center"
                        : "text-center"
                    }
                  >
                    Resource Center
                  </Link>
                </li>
              
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
